import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  show_pricing: true,
  show_gallery: true,
  show_tutorial: true,
  show_faq: true,
  show_contact: true,
  show_featured_spotlight: true,
  show_ads: false,
  show_custom_banner: false,
  signup_enabled: true,
  google_login_enabled: false,
  payments_enabled: true,
};

const FlagContext = createContext({ flags: DEFAULTS, loading: true, refresh: () => {} });

export function FlagProvider({ children }) {
  const [flags, setFlags] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await axios.get(`${API}/config/flags`);
      setFlags({ ...DEFAULTS, ...(res.data.flags || {}) });
    } catch (e) {
      setFlags(DEFAULTS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <FlagContext.Provider value={{ flags, loading, refresh }}>
      {children}
    </FlagContext.Provider>
  );
}

export const useFlags = () => useContext(FlagContext);
